import BaseModelInstance from './base.model'
import { Contact as ModelDefinition } from './model-definitions'

class Contact extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default Contact
